// Shim de `firebase/storage` — upload via notre endpoint /api/upload
// (le serveur stocke le fichier et renvoie son URL /uploads/...).

const API = "";

export function getStorage() { return { __epstore: true }; }

export function ref(_storage, path) {
  return { __epsref: true, path: path || "", _url: null };
}

export async function uploadBytes(fileRef, file) {
  const fd = new FormData();
  fd.append("path", fileRef.path || "");
  fd.append("file", file);
  const res = await fetch(`${API}/api/upload`, { method: "POST", credentials: "include", body: fd });
  if (!res.ok) throw new Error("upload " + res.status);
  const json = await res.json();
  fileRef._url = json.url;
  return { ref: fileRef };
}

export async function getDownloadURL(fileRef) { return fileRef._url; }

export default { getStorage, ref, uploadBytes, getDownloadURL };
